import storage from 'viralstyle-ui/src/storage';
import hateoas from 'viralstyle-ui/src/hateoas';

import config from 'config';
import settingsApi from '../_settings-api';

export const updateCurrentUser = async ({ commit, dispatch, rootState }) => {
  let response = await dispatch('async', () => settingsApi.updateCurrentUser(rootState.currentUser));

  response = await dispatch('getCurrentUserDetails', true);

  return response;
};

export const getSubUsers = async ({ commit, dispatch, state }, lazy) => {
  if (!state.subUsersCollection.initialized || lazy) {
    let response = await dispatch('async', () => settingsApi.getSubUsers());

    commit('setSubUsers', response.data);

    return response;
  }
};

export const saveOrUpdateSubUser = async ({ rootState, state, dispatch, commit }, user) => {
  let response = await dispatch('async', () => settingsApi.saveOrUpdateSubUser(!user.id, user, rootState.currentUserId));

  response = await dispatch('getSubUsers', true);

  return response;
};

export const removeSubUser = async ({ dispatch }, subUser) => {
  let response = await dispatch('async', () => settingsApi.removeSubUser(subUser));

  response = await dispatch('getSubUsers', true);

  return response;
};

export const updateCurrentUserPassword = async ({ dispatch, commit, rootState }) => {
  let response = await dispatch('async', () => settingsApi.updateCurrentUserPassword(rootState.currentUser.password, rootState.currentUser.newPassword));

  commit('clearCurrentUserPassword');

  return response;
};

export const getPaymentInfo = async ({ dispatch, commit }) => {
  let response = await dispatch('async', () => settingsApi.getPaymentInfo());

  commit('setPaymentInfo', response.data);

  return response;
};

export const savePaymentMethod = async ({ dispatch, commit, state }, methodOrOptions) => {
  let methodName = typeof methodOrOptions == "string" ? methodOrOptions : methodOrOptions.method,
    notificationString = `${methodName.capitalize().replace('_', ' ')} info saved`;

  if (typeof methodOrOptions != "string" && methodOrOptions.prettyName) {
    notificationString = `${methodOrOptions.prettyName} info saved`;
  }

  let response = await dispatch('async', () => settingsApi.savePaymentMethod(methodName, state.paymentInfo));

  response = await dispatch('async', () => settingsApi.getPaymentInfo());

  commit('setPaymentInfoByType', { type: methodName, info: response.data });

  commit('addNotification', notificationString);

  return response;
};

export const registerPayoneer = async ({ dispatch }) => {
  let response = await dispatch('async', () => settingsApi.getPayoneerLink());

  window.location.href = response.data.link;

  return response;
};

export const registerPingpong = async ({ dispatch }) => {
  let response = await dispatch('get', `${hateoas.url('get_new_pingpong_registration_link', { clientId: storage.get('client-hash') })}?redirect_uri=${config.PINGPONG_REDIRECT}${window.location.pathname.replace(/.+settings\//, '')}`);

  window.location.href = response.data.link;

  return response;
};

export const setDefaultPayoneer = async ({ dispatch }, id) => {
  let response = await dispatch('async', () => settingsApi.setDefaultPayoneer(id));

  response = await dispatch('getPaymentInfo');

  return response;
};

export const unlinkPayoneer = async ({ dispatch }, id) => {
  let response = await dispatch('async', () => settingsApi.unlinkPayoneer(id));

  dispatch('getPaymentInfo');

  return response;
};

export const savePingpong = async ({ rootState, dispatch }, payload) => {
  let response = await dispatch('post', {
    apiUrl: hateoas.url('add_pingpong_account', { clientId: storage.get('client-hash') }),
    payload,
  });

  response = await dispatch('getPaymentInfo');

  return response;
};

export const setDefaultPingpong = async ({ dispatch }, accountId) => {
  let response = await dispatch('post', { apiUrl: hateoas.url('make_pingpong_account_default', { clientId: storage.get('client-hash'), accountId }) });

  response = await dispatch('getPaymentInfo');

  return response;
};

export const unlinkPingpong = async ({ dispatch }, accountId) => {
  let response = await dispatch('del', hateoas.url('unlink_pingpong_account', { clientId: storage.get('client-hash'), accountId }));

  dispatch('getPaymentInfo');

  return response;
};

export const getAweberToken = async ({ dispatch }) => {
  let response = await dispatch('async', () => settingsApi.getAweberToken());

  window.location.href = response.data.url;

  return response;
};

export const saveAweberDetails = ({ dispatch }, params) => {
  return dispatch('async', () => settingsApi.saveAweberDetails(params));
};

export const getConstantContactToken = async ({ dispatch }) => {
  let response = await dispatch('async', () => settingsApi.getConstantContactToken());

  window.location.href = response.data.url;

  return response;
};

export const saveConstantContactDetails = ({ dispatch }, params) => {
  return dispatch('async', () => settingsApi.saveConstantContactDetails(params));
};

export const updateEmailProviderAndApiKey = ({ dispatch, commit }, { provider, key }) => {
  return dispatch('async', () => settingsApi.updateEmailProviderAndApiKey(provider, key));
};

export const getEmailConfig = async ({ dispatch, commit, state }, force) => {
  if (!Object.keys(state.emailConfig).length || force) {
    let response = await dispatch('async', () => settingsApi.getEmailConfig());

    commit('setEmailConfig', response.data);

    return response;
  }
}

export const refreshEmailLists = async ({ dispatch }) => {
  let response = await dispatch('async', () => settingsApi.refreshEmailLists());

  dispatch('getEmailConfig', true);

  return response;
};

export const updateCurrentEmailList = ({ dispatch }, listId) => {
  return dispatch('async', () => settingsApi.updateCurrentEmailList(listId));
};

export const updateClientPixels = async ({ dispatch, commit, rootState }) => {
  let response = await dispatch('async', () => settingsApi.updateClientPixels(rootState.currentUser));

  response = await dispatch('getCurrentUserDetails', true);

  return response;
};

export const submitPayoneerPayment = ({ state, dispatch }, amount) => {
  return dispatch('async', () => settingsApi.submitPayoneerPayment(encodeURIComponent(state.currentPayoneerAccountId), amount));
};